
import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appFilterInput]',
    standalone: false
})
export class FilterInputDirective {
  @Input() allowNegativeValue = false;
  @Input() allowDot = true;
  @Input() allowComma = true;
  private readonly SEPARATOR_OCCURRENCE_COUNT = 2;
  constructor() {}

  @HostListener('keydown', ['$event']) onKeydown(e) {
    // tslint:disable-next-line: max-line-length
    const specialKeys = [8, 9, 37, 38, 39, 40, 46]; // (backspace, tab, left arrow, up arrow, right arrow, down arrow, delete)
    const copyPasteKeys = [65, 67, 86]; // A, C, V keys
    const negativeSignKeyCodes = [189, 109];
    const dotSignKeyCodes = [190, 110];
    const numericalKeyCodes = [...this.createRange(48,57), ...this.createRange(96, 105)];

    const keyCode = e.keyCode;
    let value = e.target.value;

    if (e.ctrlKey && copyPasteKeys.includes(keyCode)) {
      return true;
    }

    if (value === null) {
      value = '';
    }

    if (this.allowDot === false && dotSignKeyCodes.includes(keyCode)) return false;

    if (this.allowComma === false && keyCode === 188) return false;

    // Check if negative value is allowed
    if (this.allowNegativeValue === true && negativeSignKeyCodes.includes(keyCode)) {
        return value.indexOf('-') === -1;
    }

    e.target.value = value === '.' || value === ',' ? `0${value}` : value;

    // dot
    if (dotSignKeyCodes.includes(keyCode) && value.indexOf(',') === -1) {
        // Check if the text already contains the . character
        return value.indexOf('.') === -1;
    } else if (keyCode === 188 && value.indexOf('.') === -1) { // comma
        // Check if the text already contains the , character
        return value.indexOf(',') === -1;
    } else { // check for some special keys and numbers
        if (specialKeys.includes(keyCode) || numericalKeyCodes.includes(keyCode)) {
        return true;
        }
    }
    return false;
  }

 @HostListener('paste', ['$event']) onPaste(e) {

   const pastedValue = e.clipboardData.getData('text');

   const characters = pastedValue.split('');

   const isNumeric = (c) => /\d/.test(c);

   const commas = characters.filter(c => c === ',').length;
   const periods = characters.filter(c => c === '.').length;
   const spaces = characters.filter(c => c === ' ').length;
   const digits = characters.filter(c => isNumeric(c)).length;

   const isNumberBasedOnSeparatorCount = this.isNumberBasedOnSeparatorCount(pastedValue.length, digits, commas) ||
                                         this.isNumberBasedOnSeparatorCount(pastedValue.length, digits, periods) ||
                                         this.isNumberBasedOnSeparatorCount(pastedValue.length, digits, spaces);

   const isNumberBasedOnSpaceCommaCombination = this.isNumberBasedOnSeparatorCombination(pastedValue.length, digits, spaces, commas);
   const isNumberBasedOnSpacePeriodCombination = this.isNumberBasedOnSeparatorCombination(pastedValue.length, digits, spaces, periods);
   const isNumberBasedOnCommaPeriodCombination = this.isNumberBasedOnSeparatorCombination(pastedValue.length, digits, commas, periods);

   const isNumberBasedOnSeparatorCombination = isNumberBasedOnSpaceCommaCombination ||
                                               isNumberBasedOnSpacePeriodCombination ||
                                               isNumberBasedOnCommaPeriodCombination;

   const isNumber = isNumberBasedOnSeparatorCount || isNumberBasedOnSeparatorCombination;

   if (isNumber) {
     e.target.value = '';
   }

   return isNumber;
 }

 private isNumberBasedOnSeparatorCount(initialValueCharacterCount: number, digitCount: number, allowedCharactersCount: number) {

  return (digitCount === initialValueCharacterCount && allowedCharactersCount === 0) ||
         (digitCount === initialValueCharacterCount - 1 && allowedCharactersCount === 1);
 }

 private isNumberBasedOnSeparatorCombination(initialValueCharacterCount: number, digitCount: number,
                                  firstSeparatorCount: number, secondSeparatorCount: number) {

   return (firstSeparatorCount < this.SEPARATOR_OCCURRENCE_COUNT && secondSeparatorCount < this.SEPARATOR_OCCURRENCE_COUNT &&
           digitCount === initialValueCharacterCount - (firstSeparatorCount + secondSeparatorCount))
 }

  private createRange(start, end) {
    if(start === end) {
      return [start];
    }
    return [start, ...this.createRange(start + 1, end)];
  }
}
